import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";


export interface DebugInterface{
    idjob:number;
    status?:{status?:string; key?:string; error?:boolean;};
    log?:object;
    debugging:string;
    threadName:string;
   
}


@Injectable({
  providedIn: 'root',
})

export class WebhookDebugServices {
    private debugSubject = new BehaviorSubject<DebugInterface>(null);
    debugging$ = this.debugSubject.asObservable();

    updateDebug(newDebug: DebugInterface) {
        this.debugSubject.next(newDebug);
    }

}